var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgMastercardLogo = function SvgMastercardLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.208,
    y: 0.208,
    width: 28.75,
    height: 19.583,
    rx: 2.292,
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 0.417
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.75 14.485a5.626 5.626 0 01-3.688 1.373c-3.14 0-5.686-2.575-5.686-5.752 0-3.177 2.546-5.752 5.686-5.752 1.408 0 2.696.517 3.689 1.373a5.626 5.626 0 013.688-1.373c3.14 0 5.686 2.575 5.686 5.752 0 3.177-2.546 5.752-5.686 5.752a5.626 5.626 0 01-3.688-1.373z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.75 14.485a5.767 5.767 0 001.999-4.379 5.767 5.767 0 00-1.998-4.379 5.626 5.626 0 013.688-1.373c3.14 0 5.686 2.575 5.686 5.752 0 3.177-2.546 5.752-5.686 5.752a5.626 5.626 0 01-3.688-1.373z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.748 14.484a5.767 5.767 0 001.998-4.378 5.767 5.767 0 00-1.998-4.379 5.767 5.767 0 00-1.998 4.379c0 1.753.775 3.323 1.998 4.378z",
    fill: "#FF5E00"
  })));
};
export default SvgMastercardLogo;